<template>
    <b-modal
        id="code-selection-modal"
        title="Select code destination"
        size="md"
        title-class="font-18"
        hide-header-close
        hide-footer
        centered
    >
        <div class="text-center">
            <p class="mb-4">
                Choose where to send the verification code.
            </p>
            <div class="d-flex flex-column flex-sm-row justify-content-center gap-2">
                <b-button variant="primary" class="px-4" @click="selectOption('phone')">
                    Phone
                </b-button>
                <b-button variant="outline-primary" class="px-4" @click="selectOption('email')">
                    Email
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'CodeSelectionModal',
    data() {
        return {
            resolver: null,
        };
    },
    methods: {
        fire() {
            return new Promise((resolve) => {
                this.resolver = resolve;
                this.$bvModal.show('code-selection-modal');
            });
        },
        selectOption(option) {
            if (this.resolver) {
                this.resolver(option);
                this.resolver = null;
            }
            this.$bvModal.hide('code-selection-modal');
        },
    },
};
</script>